import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { Link as RouterLink } from 'react-router-dom';
import useCategories from '../../services/useCategories';
import FooterColumnHeading from './FooterColumnHeading';
import { FOOTER_LIST_SX, FOOTER_LIST_GRID_SX, FOOTER_LINK_SX } from './styles';

function CategoriesColumn({ heading, showHeading = true, gridLayout = false }) {
    const { categories, loading } = useCategories();

    return (
        <Box data-testid="redesign-footer-categories">
            {showHeading ? <FooterColumnHeading>{heading}</FooterColumnHeading> : null}
            <Box
                component="ul"
                sx={gridLayout ? FOOTER_LIST_GRID_SX : FOOTER_LIST_SX}
                aria-busy={loading || undefined}
                data-testid="redesign-footer-categories-list"
            >
                {categories.map(category => (
                    <Box
                        component="li"
                        key={category.id}
                        sx={gridLayout ? { width: { md: '25%' } } : null}
                    >
                        <Box
                            component={RouterLink}
                            to={`/category/${category.id}`}
                            sx={FOOTER_LINK_SX}
                            data-testid={`redesign-footer-category-${category.id}`}
                        >
                            {category.name}
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}

CategoriesColumn.propTypes = {
    heading: PropTypes.string.isRequired,
    showHeading: PropTypes.bool,
    gridLayout: PropTypes.bool,
};

export default CategoriesColumn;
